import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { FinalCustomersService } from '../../services/finalCustomersService';
import { getFullName } from '../../utility/finalCustomerUtils';
import { finalCustomerSolutionIdRules } from '../../config/constants/finalCustomerSolutionRuleConstants';

export const SelectFinalCustomer = ({ selectedFinalCustomer, onChange, multiple = false, disabled, allowedClear }) => {
  const { translate: t } = useDictionaryTranslation();
  const [finalCustomers, setFinalCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const solutionId = useSelector((state) => state.auth?.accountData?.solutionId);
  const finalCustomerSolutionRules = finalCustomerSolutionIdRules[solutionId] ?? finalCustomerSolutionIdRules.default;

  const selectFinalCustomer = (item) => {
    let selectedOption;
    if (item) selectedOption = finalCustomers.find((s) => s._id === item.value);
    onChange(selectedOption);
  };

  const selectFinalCustomers = (items) => {
    const selectedCustomers = items.map((customer) => customer.value);
    onChange(selectedCustomers);
  };

  const getFinalCustomers = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search };
      const { finalCustomers: finalCustomersList } = await FinalCustomersService.getAll(params);
      setFinalCustomers(finalCustomersList);
    } catch (error) {
      setFinalCustomers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((finalCustomer) => {
    return {
      value: finalCustomer._id,
      label: `${getFullName(finalCustomer, { useFullName: finalCustomerSolutionRules.showName1 })} - ${
        finalCustomer.identification
      }`,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('finalCustomerPlaceholder')}
      isLoading={loading}
      onChange={multiple ? selectFinalCustomers : selectFinalCustomer}
      options={finalCustomers}
      value={selectedFinalCustomer}
      onSearch={getFinalCustomers}
      getOptionData={getOptionData}
      multiple={multiple}
      disabled={disabled}
      allowClear={allowedClear}
    />
  );
};

SelectFinalCustomer.propTypes = {
  selectedFinalCustomer: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  allowedClear: PropTypes.bool,
};
